import type { IconData } from '@stacksjs/iconify-core'

export const pyramidShapeSolid: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M25.5 46.392c2.395-.314 5.45-1.272 8.397-2.358c3.684-1.357 7.461-3.016 10.116-4.235a5.3 5.3 0 0 0 2.473-7.337C40.169 20.678 31.59 8.672 27.528 3.188A4.4 4.4 0 0 0 25.5 1.665zm-3-44.727a4.4 4.4 0 0 0-2.027 1.523C16.41 8.672 7.833 20.678 1.515 32.462a5.3 5.3 0 0 0 2.473 7.337c2.655 1.219 6.431 2.878 10.116 4.235c2.947 1.086 6 2.044 8.396 2.358z\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default pyramidShapeSolid
